import EllipsisText from '@cp/src/components/EllipsisText';
import { Tooltip, TooltipContent, TooltipTrigger } from '@cp/src/components/TooltipV2/TooltipV2';
import React from 'react';
import cx from 'classnames';

interface IRenderWithToolTip {
  value: string;
  toolTipContent?: string;
  showToolTip?: boolean;
  lineClamp?: number;
  hiddenPadding?: number;
  ellipsisWrapperClass?: string;
  tooltipContentClass?: string;
}

const TableCellRenderer: React.FC<IRenderWithToolTip> = props => {
  const {
    value,
    toolTipContent,
    showToolTip,
    lineClamp = 1,
    hiddenPadding = 10,
    ellipsisWrapperClass,
    tooltipContentClass
  } = props;

  if (!showToolTip) {
    return (
      <EllipsisText
        text={value ?? '-'}
        lineClamp={lineClamp}
        ellipsisWrapperClass={ellipsisWrapperClass}
      />
    );
  }

  return (
    <Tooltip placement="top" hiddenPadding={hiddenPadding} hideStrategy="referenceHidden">
      <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper">
        <EllipsisText
          text={value ?? '-'}
          lineClamp={lineClamp}
          ellipsisWrapperClass={ellipsisWrapperClass}
        />
      </TooltipTrigger>
      {toolTipContent ? (
        <TooltipContent className={cx('tooltipWrapper', tooltipContentClass)}>
          {toolTipContent}
        </TooltipContent>
      ) : null}
    </Tooltip>
  );
};

export default TableCellRenderer;
